const BlogListSelect = {
    init() {
        // Select responsive from page "actualités"
        const select_resp_post_filter = document.getElementById('post-list-select-resp');

        if (select_resp_post_filter) {
            select_resp_post_filter.addEventListener('change', function() {
                document.querySelector('.wrapper-post-list-category .post-list-category .post-category-link a[href=\"' + this.value + '\"]').click();
            });
        }

        const select_tabs_pro_list_filter = document.getElementById('tabs-pro-list-select-resp');

        if (select_tabs_pro_list_filter) {
            select_tabs_pro_list_filter.addEventListener('change', function() {
                document.querySelector('.tabs-pro-section .tabs-pro-container .tabs-pro-list .tabs-pro-item a[data-slug=\"' + this.value + '\"]').click();
                // console.log(this.value);
            });
        }

        const select_tabs_list_filter = document.getElementById('tabs-list-select-resp');

        if (select_tabs_list_filter) {
            select_tabs_list_filter.addEventListener('change', function() {
                document.querySelector('.payment-section .payment-container .payment-header .list-payment-type .payment-type a[data-slug=\"' + this.value + '\"]').click();
                // console.log(this.value);
            });
        }
    }
}

export default BlogListSelect;